

























































































































































































import {
  ResponseStatus,
  TeamTokenInfo,
  TournamentAPI,
  TournamentEntity
} from '@/api/tournament'
import { Vue, Component } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournament from '@/modules/tournament/tournament.store'
import member from '@/modules/member/member.store'
import auth from '@/modules/auth/auth.store'
import ServerError from '@/utils/server_error'
import InGameNameDialog from './InGameNameDialog'
import TermsAndConditionsDialog from './TermsAndConditionsDialog'
import InviteActionDialog from './InviteActionDialog'
import { IdentityAPI } from '@/api/identity'
import PhoneNumberVerificationDialog from '@/modules/member/components/PhoneNumberVerificationDialog'
import { ensureTournamentVerification } from '@/utils/verification'
import JoinTournamentSetDiscordIdDialog from '@/modules/member/components/JoinTournamentSetDiscordIdDialog'

@Component({
  components: {
    JoinTournamentSetDiscordIdDialog,
    InGameNameDialog,
    InviteActionDialog,
    PhoneNumberVerificationDialog
  }
})
export default class InviteToken extends Vue {
  isInitializing: boolean = true
  isLoading: boolean = false
  isJoiningTeam: boolean = false
  isActionDialogVisible: boolean = false
  isBackgroundError: boolean = false
  isLocalClientAvailable: boolean = false
  tournament: TournamentEntity | null = null
  hasJoinedTournament: boolean = false
  tokenInfo: TeamTokenInfo | null = null
  authModule = getModule(auth, this.$store)
  memberModule = getModule(member, this.$store)
  tournamentModule = getModule(tournament, this.$store)

  // custom form
  schema: any = {}
  formResponse: any = null

  async created() {
    if (!this.inviteToken) {
      this.isInitializing = false
    }

    setTimeout(async () => {
      await this.fetchData()
      await this.checkJoinedTournament()
    }, 1000)
  }

  get inviteToken() {
    if (!this.$route.params || !this.$route.params.inviteToken) {
      return ''
    }
    return this.$route.params.inviteToken
  }

  get isAuthenticated() {
    return this.authModule.oidcIsAuthenticated
  }

  onPhoneVerificationSuccess() {
    this.isActionDialogVisible = true
  }

  async onJoinTeam() {
    if (
      !(await ensureTournamentVerification({
        tournament: this.tournament!,
        callback: this.onJoinTeam
      }))
    ) {
      return
    }
    this.isActionDialogVisible = true
  }

  async fetchData() {
    try {
      const response = await TournamentAPI.getTeamTokenInformation(
        this.inviteToken
      )
      if (response.data.payload) {
        this.tokenInfo = response.data.payload

        const tournamentResponse = await TournamentAPI.getTournament(
          this.tokenInfo.tournamentId
        )
        this.attemptLocalClient()
        const payload = tournamentResponse.data.payload
        if (payload) {
          this.tournament = payload
          this.tournamentModule.setSelectedTournament(
            this.tokenInfo.tournamentId
          )

          // check joined another instant match
          if (this.isAuthenticated && this.tournament.isAutomated) {
            try {
              const res = await TournamentAPI.getMemberJoinedAutomatedTournament()
              if (res.data.payload!.isJoined) {
                this.$toast.error(
                  this.$t(
                    'InstantMatchActionButtons.JoinedAnotherInstantMatchAlready'
                  )
                )
                await this.$router.push({
                  name: 'InstantMatchDetails',
                  params: {
                    tournamentId: res.data.payload!.tournamentId
                  }
                })
                return
              }
            } catch (err) {
              if (err instanceof ServerError) {
                this.$toast.error(err.getMessage())
              } else {
                this.$toast.error(this.$t('Loading.SystemErrorMessage'))
              }
              console.error(err)
            }
          }
        }
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        console.error(err)
      }
    } finally {
      this.isLoading = false
    }
  }

  async authenticate() {
    this.authModule.authenticateOidc(this.$route.fullPath)
  }

  async reject() {
    this.$toast.error(this.$t('InviteToken.RejectedInvite'))
    this.$router.push('/')
  }

  async checkJoinedTournament() {
    try {
      const response = await TournamentAPI.getMemberJoinedTournaments()
      const payload = response.data.payload

      if (payload && this.tokenInfo) {
        if (
          payload
            .map(tournament => tournament.tournamentId)
            .includes(this.tokenInfo.tournamentId)
        ) {
          this.hasJoinedTournament = true
        }
      }
    } catch {
    } finally {
      this.isInitializing = false
    }
  }

  get backgroundStyle() {
    if (this.isBackgroundError) {
      return {
        backgroundImage: `url(${require('@/assets/default/tournament_background.png')})`
      }
    }
    return {
      backgroundImage: `url(${
        this.tournament !== null ? this.tournament.detailBanner : ''
      })`
    }
  }

  get game() {
    if (!this.tournament) return null

    const isValorant = this.tournament.game.toLowerCase() === 'valorant'

    return {
      code: isValorant ? 'valorant' : 'lol',
      title: isValorant ? '特戰英豪' : '英雄聯盟',
      name: isValorant ? 'Valorant' : 'League of Legends'
    }
  }

  async joinTeam(formResponse: any) {
    if (!this.tokenInfo || !this.isAuthenticated || !this.tournament) return

    this.isJoiningTeam = true
    try {
      const response = await TournamentAPI.joinTournamentTeamByTeamToken(
        this.inviteToken
      )
      if (response.data.status === ResponseStatus.Ok) {
        this.$toast.success(this.$t('InviteToken.SuccessfullyJoined'))

        // if form response
        if (formResponse) {
          this.submitTournamentFormResponse(formResponse)
        }
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      }
      console.error(err)
    } finally {
      setTimeout(() => {
        this.isJoiningTeam = false
        this.$router.push({
          name: 'TournamentDetailsOverview',
          params: {
            tournamentId: this.tournament!.tournamentId
          }
        })
      }, 1000)
    }
  }

  async submitTournamentFormResponse(formResponse: string) {
    try {
      const response = await TournamentAPI.submitTournamentFormResponse(
        this.tokenInfo!.tournamentTeamId,
        JSON.stringify(formResponse)
      )
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('TournamentActionDialog.SystemErrorMessage'))
        console.error(err)
      }
    }
  }

  async attemptLocalClient() {
    const promises = []

    for (let port = 5111; port <= 5121; port++) {
      promises.push(
        fetch('http://localhost:' + port + '/redeemTeamToken', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            token: this.inviteToken
          })
        })
      )
    }

    let succeed = false

    Promise.race(promises)
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText)
        }
        this.isLocalClientAvailable = true
      })
      .catch(() => {})
  }
}
